import * as React from 'react';

import { AiPromptPill } from 'bundles/search-common/components/AiPromptPill';
import {
  ASK_ANYTHING_AI_PROMPT_ID,
  ASK_ANYTHING_ROUTE_TYPE,
} from 'bundles/search-common/components/experiments/aiSearchOnLohp/constants';

type Props = {
  id: string;
  name: string;
  routeType?: string;
  groupId?: string;
};

const AutocompleteAiPromptOption = ({ id, name, routeType, groupId }: Props) => {
  const isAskAnything = id === ASK_ANYTHING_AI_PROMPT_ID || routeType === ASK_ANYTHING_ROUTE_TYPE;

  // TODO: onClick is intentionally not forwarded here. Pill selection is handled at the
  // Autocomplete level via onSelectionChange in SearchBarContent, which routes the item
  // ID through handleSubmit → handleAutocompleteSubmit.
  return (
    <span data-group={groupId}>
      <AiPromptPill label={name} size="small" variant={isAskAnything ? 'alive' : 'white'} />
    </span>
  );
};

export default AutocompleteAiPromptOption;
